import React from 'react';
import { twMerge } from 'tailwind-merge';

const FormSelect = ({
    label,
    id,
    value,
    onChange,
    required = false,
    error,
    helpText,
    className = '',
    wrapperClassName = '',
    htmlFor,
    children
}) => {
    const selectId = id || label?.toLowerCase().replace(/\s+/g, '-');

    // Base select classes to match your input theme
    const baseSelectClasses = `
        appearance-none
        block
        px-4
        py-2
        w-full
        border
        border-gray-200
        rounded-md
        shadow-sm
        text-sm
        focus:outline-none
        focus:ring-2
        focus:ring-offset-0
       
        bg-white
        pr-10
        transition-colors
    `;

    // Use twMerge to combine base classes with any custom classes
    const selectClasses = twMerge(baseSelectClasses, className);
    const containerClasses = twMerge('w-full', wrapperClassName);

    return (
        <div className={containerClasses}>
            {label && (
                <label
                    htmlFor={htmlFor || selectId}
                    className="block text-sm font-medium text-gray-700 mb-1 ml-1"
                >
                    {label}
                    {required && <span className="text-red-500 ml-1">*</span>}
                </label>
            )}
            <div className="relative">
                <select
                    id={selectId}
                    value={value}
                    onChange={onChange}
                    required={required}
                    className={selectClasses}
                >
                    {children}
                </select>
                {/* Custom dropdown icon */}
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                    <svg className="h-4 w-4" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                        <path d="M19 9l-7 7-7-7"></path>
                    </svg>
                </div>
            </div>
            {(error || helpText) && (
                <p className={`mt-1 text-sm ${error ? 'text-red-600' : 'text-gray-500'}`}>
                    {error || helpText}
                </p>
            )}
        </div>
    );
};

export default FormSelect;